<template>
  <page-option :disable-add="!checkAccess('workspace.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-alert-rhombus-outline</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">File log lỗi hệ thống</div>
    </template>
    <v-data-table
      class=" fill-height overflow-hidden custom-table"
      :items="items"
      :headers="headers"
      fixed-header
      :loading="loading"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="previewFile(item)"
              icon
              v-on="on"
              style="margin-left: -8px"
            >
              <v-icon>mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>Xem</span>
        </v-tooltip>
        <base-button
          @click="remove(item)"
          icon
          type-action="delete"
          v-on="on"
          :loading="loadingDelete == item.id"
          :disabled="loadingDelete != -1 && loadingDelete != item.id"
        >
        </base-button>
      </template>
    </v-data-table>
    <LogPreview ref="log_preview" />
  </page-option>
</template>
<script>
import { API_OVERVIEW } from '@api'
import LogPreview from './log-preview.vue'
import { ConfirmBuilder } from '@utils'
export default {
  components: {
    LogPreview,
  },
  data: () => ({
    headers: [
      { text: 'Tên File', value: 'name', sortable: false },
      { text: 'Dung lượng', value: 'size', sortable: false },
      { text: 'Ngày tạo', value: 'modify', sortable: false },
      // { text: 'Thời gian', value: 'time', sortable: false },
      // {text: 'Ngày tạo', value: 'size', sortable:false},
      { text: 'Hoạt động', value: 'action', sortable: false },
    ],
    loading: false,
    items: [],
    loadingDelete: -1,
  }),
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const res = await API_OVERVIEW.logFileIndex()
      this.items = res.data
      this.loading = false
    },
    async previewFile(item) {
      const res = await API_OVERVIEW.previewFile({ path: item.path })
      if (res && res.isDone) {
        let file = new Blob([res.data], { type: 'text/plain' })
        let url = URL.createObjectURL(file)
        this.$refs.log_preview.open(url, item.name)
      }
    },
    async remove(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        this.loadingDelete = item.id
        const result = await API_OVERVIEW.destroy({ path: item.path })
        if (result.isDone) {
          this.fetchData()
        }
        this.loadingDelete = -1
        return result
      }
    },
  },
}
</script>
